import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectAppliedPoliciesFragment = { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null } | null, shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null } | null, sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null } | null } | null };

export const ProjectAppliedPolicies = /*#__PURE__*/ gql`
    fragment ProjectAppliedPolicies on Project {
  id
  appliedResourceControlPolicies {
    downloads {
      shareDownloadingEnabled
    }
    shareAccess {
      default
      minimum
    }
    sharePassphrase {
      required
    }
  }
}
    ` as unknown as DocumentNode<ProjectAppliedPoliciesFragment, unknown>;

        

        
export const useProjectAppliedPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<ProjectAppliedPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectAppliedPoliciesFragment>({
    fragment: ProjectAppliedPolicies,
    fragmentName: 'ProjectAppliedPolicies',
    ...options,
  });
};
  
        